import { Readable } from 'stream';
export class ReadStream extends Readable {
    readStdin;
    closeStdin;
    pollingInterval = 100;
    constructor(readStdin, closeStdin) {
        super();
        this.readStdin = readStdin;
        this.closeStdin = closeStdin;
    }
    _read(size) {
        this.readStdin(size)
            .then(async (data) => {
            while (data && data.length === 0 && this.readableFlowing) {
                await new Promise((resolve) => setTimeout(resolve, this.pollingInterval));
                if (!this.readableFlowing) {
                    return;
                }
                data = await this.readStdin(size);
            }
            this.push(data);
        })
            .catch((err) => this.destroy(err));
    }
    _destroy(err, callback) {
        // TODO: Which error should we prioritize? The one from the destroy call or
        // the one from the closeStdin call?
        this.closeStdin()
            .then(() => callback(err))
            .catch((closeErr) => callback(closeErr));
    }
}
